module.exports = __webpack_public_path__ + "static/media/news.7a398e60.svg";